var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("textarea", {
        staticStyle: { display: "none" },
        attrs: { name: "focus", id: "quitfocus", rows: "3" },
      }),
      _vm._v(" "),
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "6" } },
            [
              _vm.currentStep > 0
                ? _c(
                    "vs-button",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        id: "prev2",
                        color: "primary",
                        type: "filled",
                        "icon-pack": "feather",
                        icon: "icon-chevron-left",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.prevClickHandle.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n                Précédent\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "vs-button",
                {
                  attrs: {
                    id: "goBack",
                    color: "primary",
                    type: "border",
                    "icon-pack": "feather",
                    icon: "icon-arrow-left",
                    href: _vm.backUrl,
                  },
                },
                [_vm._v("\n                Sortir\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-col",
            {
              attrs: {
                "vs-w": "6",
                "vs-type": "flex",
                "vs-justify": "flex-end",
              },
            },
            [
              !_vm.isLastStep
                ? _c(
                    "vs-button",
                    {
                      attrs: {
                        id: "next2",
                        color: "primary",
                        type: "filled",
                        "icon-pack": "feather",
                        icon: "icon-chevron-right",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.nextClickHandle.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n                Suivant\n            ")]
                  )
                : _c(
                    "vs-button",
                    {
                      attrs: {
                        id: "submit2",
                        color: "primary",
                        type: "filled",
                        "icon-pack": "feather",
                        icon: "icon-check",
                      },
                      on: { click: _vm.nextClickHandle },
                    },
                    [
                      _vm.typeForm === "consultation"
                        ? _c("span", [
                            _vm._v(
                              "\n                    Retour\n                "
                            ),
                          ])
                        : _vm.skillReview
                        ? _c(
                            "span",
                            [
                              _vm.canValidateSkillReview
                                ? [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            Valider le " +
                                          _vm._s(
                                            _vm.skillRatingNames.singular.toLowerCase()
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            Soumettre pour validation\n                        "
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          )
                        : _c(
                            "span",
                            [
                              _vm.canValidateProject
                                ? [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            Valider le " +
                                          _vm._s(
                                            _vm.projectNames.singular.toLowerCase()
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            Soumettre pour validation\n                        "
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.employee
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c(
                "form-wizard",
                {
                  ref: "formWizard",
                  attrs: {
                    color: "rgba(var(--vs-primary), 1)",
                    "error-color": "rgba(var(--vs-danger), 1)",
                    "start-index": _vm.currentStep,
                    subtitle: null,
                  },
                  on: {
                    "on-complete": _vm.endFormHandle,
                    "on-validate": _vm.validateFormHandle,
                    "on-error": _vm.errorFormHandle,
                    "on-change": _vm.changePageHandle,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "footer",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "wizard-footer-left",
                                attrs: { onclick: "window.scrollTo(0,0)" },
                              },
                              [
                                props.activeTabIndex > 0
                                  ? _c(
                                      "vs-button",
                                      {
                                        attrs: {
                                          id: "prev",
                                          color: "primary",
                                          type: "filled",
                                          "icon-pack": "feather",
                                          icon: "icon-chevron-left",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.prevClickHandle.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        Précédent\n                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "wizard-footer-right",
                                attrs: { onclick: "window.scrollTo(0,0)" },
                              },
                              [
                                !props.isLastStep
                                  ? _c(
                                      "vs-button",
                                      {
                                        staticClass: "wizard-footer-right",
                                        attrs: {
                                          id: "next",
                                          color: "primary",
                                          type: "filled",
                                          "icon-pack": "feather",
                                          icon: "icon-chevron-right",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.nextClickHandle.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        Suivant\n                    "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "vs-button",
                                      {
                                        staticClass:
                                          "wizard-footer-right finish-button",
                                        attrs: {
                                          id: "submit",
                                          color: "primary",
                                          type: "filled",
                                          "icon-pack": "feather",
                                          icon: "icon-check",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.nextClickHandle.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.typeForm === "consultation"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                            Retour\n                        "
                                              ),
                                            ])
                                          : _vm.skillReview
                                          ? _c(
                                              "span",
                                              [
                                                _vm.canValidateSkillReview
                                                  ? [
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                                    Valider le " +
                                                            _vm._s(
                                                              _vm.skillRatingNames.singular.toLowerCase()
                                                            ) +
                                                            "\n                                "
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                                    Soumettre pour validation\n                                "
                                                        ),
                                                      ]),
                                                    ],
                                              ],
                                              2
                                            )
                                          : _c(
                                              "span",
                                              [
                                                _vm.canValidateProject
                                                  ? [
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                                    Valider le " +
                                                            _vm._s(
                                                              _vm.projectNames.singular.toLowerCase()
                                                            ) +
                                                            "\n                                "
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                                    Soumettre pour validation\n                                "
                                                        ),
                                                      ]),
                                                    ],
                                              ],
                                              2
                                            ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1392186671
                  ),
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "wizard-custom-title",
                      attrs: { slot: "title" },
                      slot: "title",
                    },
                    [
                      _vm._v(
                        "\n                " + _vm._s(_vm.titleWord) + " de "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.titleName))]),
                      _vm._v(
                        " du " +
                          _vm._s(_vm.titleDate) +
                          " " +
                          _vm._s(_vm.titleComplement) +
                          " (" +
                          _vm._s(_vm.titleEstablishmentsServicesNames) +
                          ")\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.typeForm !== "consultation"
                    ? _c(
                        "vs-button",
                        {
                          attrs: {
                            id: "saveQuit",
                            color: "primary",
                            type: "filled",
                            "icon-pack": "feather",
                            icon: "icon-save",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.saveProjectClickHandle.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v("\n                Sauvegarder\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorValidateMessage
                    ? _c(
                        "div",
                        { staticClass: "mb-10" },
                        [
                          _c(
                            "vs-alert",
                            { attrs: { color: "danger", active: "true" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.errorValidateMessage) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      staticClass: "mb-5",
                      attrs: {
                        title: "Périmètre",
                        icon: "feather icon-crosshair",
                        "before-change": _vm.validatePerimeter,
                      },
                    },
                    [
                      _c(
                        "form",
                        {
                          attrs: {
                            "data-vv-scope": `step-${_vm.getStepFromName(
                              "perimeter"
                            )}`,
                          },
                        },
                        [
                          _c("Perimeter-Tab", {
                            attrs: {
                              "type-form": _vm.typeForm,
                              "skill-review": _vm.skillReview,
                              jobs: _vm.orderedJobs,
                              occupations: _vm.orderedOccupations,
                              defaultOccSkillPerimeter:
                                _vm.lastRating.perimeter_occskills || [],
                              "externals-usage-values":
                                _vm.externalsUsageValues,
                              employeePerimeter: {
                                employeeJobs: _vm.employeeJobs,
                                employeeOccupations: _vm.employeeOccupations,
                                employeeOccupationSkills:
                                  _vm.employeeOccupationSkills,
                              },
                            },
                            on: {
                              "career-updated": function ($event) {
                                _vm.careerUpdated = true
                              },
                              "initial-loading": function ($event) {
                                _vm.initialLoadingPerimeter = false
                              },
                            },
                            model: {
                              value: _vm.resource,
                              callback: function ($$v) {
                                _vm.resource = $$v
                              },
                              expression: "resource",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      staticClass: "mb-5",
                      attrs: {
                        title: "Évaluation des savoir-faire",
                        icon: "feather icon-aperture",
                        "before-change": _vm.validateOccupationSkills,
                      },
                    },
                    [
                      _c(
                        "form",
                        {
                          attrs: {
                            "data-vv-scope": `step-${_vm.getStepFromName(
                              "occupation-skills"
                            )}`,
                          },
                        },
                        [
                          _vm.currentStep ==
                          _vm.getStepFromName("occupation-skills")
                            ? _c("Occupation-Skills-Rating-Tab", {
                                key: _vm.updateRatingList,
                                attrs: {
                                  "type-form": _vm.typeForm,
                                  "skill-review": _vm.skillReview,
                                  jobColors: _vm.jobColors,
                                  occupationColors: _vm.occupationColors,
                                },
                                model: {
                                  value: _vm.resource,
                                  callback: function ($$v) {
                                    _vm.resource = $$v
                                  },
                                  expression: "resource",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      staticClass: "mb-5",
                      attrs: {
                        title: "Évaluation des compétences",
                        icon: "feather icon-award",
                        "before-change": _vm.validateSkills,
                      },
                    },
                    [
                      _c(
                        "form",
                        {
                          attrs: {
                            "data-vv-scope": `step-${_vm.getStepFromName(
                              "skills"
                            )}`,
                          },
                        },
                        [
                          _vm.currentStep == _vm.getStepFromName("skills") &&
                          !_vm.occupationSkillOnly
                            ? _c("Skills-Rating-Tab", {
                                key: _vm.updateRatingList,
                                attrs: {
                                  "type-form": _vm.typeForm,
                                  "skill-review": _vm.skillReview,
                                  "admin-skills": _vm.adminSkills,
                                  colors: _vm.colors.data,
                                  jobColors: _vm.jobColors,
                                  occupationColors: _vm.occupationColors,
                                },
                                model: {
                                  value: _vm.resource,
                                  callback: function ($$v) {
                                    _vm.resource = $$v
                                  },
                                  expression: "resource",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.skillReview && _vm.occupationSkillsSeftRating
                    ? _c(
                        "tab-content",
                        {
                          staticClass: "mb-5",
                          attrs: {
                            title: "Auto-évaluation savoir-faire",
                            icon: "feather icon-check-square",
                            "before-change": _vm.validateSelfOccupationSkills,
                          },
                        },
                        [
                          _c(
                            "form",
                            {
                              attrs: {
                                "data-vv-scope": `step-${_vm.getStepFromName(
                                  "self-occupation-skills"
                                )}`,
                              },
                            },
                            [
                              _vm.currentStep ==
                              _vm.getStepFromName("self-occupation-skills")
                                ? _c("SelfOccupationSkillsRatingTab", {
                                    key: _vm.updateRatingList,
                                    attrs: {
                                      "type-form": _vm.typeForm,
                                      "skill-review": _vm.skillReview,
                                      "self-rating-source-values":
                                        _vm.selfRatingSourceValues,
                                      jobColors: _vm.jobColors,
                                      occupationColors: _vm.occupationColors,
                                    },
                                    model: {
                                      value: _vm.resource,
                                      callback: function ($$v) {
                                        _vm.resource = $$v
                                      },
                                      expression: "resource",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.skillReview
                    ? _c(
                        "tab-content",
                        {
                          staticClass: "mb-5",
                          attrs: {
                            title: "Auto-évaluation compétence",
                            icon: "feather icon-user-check",
                            "before-change": _vm.validateSelfSkills,
                          },
                        },
                        [
                          _c(
                            "form",
                            {
                              attrs: {
                                "data-vv-scope": `step-${_vm.getStepFromName(
                                  "self-skills"
                                )}`,
                              },
                            },
                            [
                              !_vm.occupationSkillOnly &&
                              _vm.currentStep ==
                                _vm.getStepFromName("self-skills")
                                ? _c("Self-Rating-Tab", {
                                    key: _vm.updateRatingList,
                                    attrs: {
                                      "type-form": _vm.typeForm,
                                      "skill-review": _vm.skillReview,
                                      "self-rating-source-values":
                                        _vm.selfRatingSourceValues,
                                      "admin-skills": _vm.adminSkills,
                                      colors: _vm.colors.data,
                                      jobColors: _vm.jobColors,
                                      occupationColors: _vm.occupationColors,
                                    },
                                    model: {
                                      value: _vm.resource,
                                      callback: function ($$v) {
                                        _vm.resource = $$v
                                      },
                                      expression: "resource",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      staticClass: "mb-5",
                      attrs: {
                        title: "Objectifs & Synthèse",
                        icon: "feather icon-briefcase",
                        "before-change": _vm.validateGoalsAndSynthesis,
                      },
                    },
                    [
                      _c(
                        "form",
                        {
                          attrs: {
                            "data-vv-scope": `step-${_vm.getStepFromName(
                              "goals-and-synthesis"
                            )}`,
                          },
                        },
                        [
                          _vm.currentStep ==
                          _vm.getStepFromName("goals-and-synthesis")
                            ? _c("Goals-And-Synthesis-Tab", {
                                attrs: {
                                  "type-form": _vm.typeForm,
                                  jobs: _vm.orderedJobs,
                                  occupations: _vm.orderedOccupations,
                                  jobColors: _vm.jobColors,
                                  occupationColors: _vm.occupationColors,
                                  states: _vm.states,
                                },
                                model: {
                                  value: _vm.resource,
                                  callback: function ($$v) {
                                    _vm.resource = $$v
                                  },
                                  expression: "resource",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }